import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/app-theme.css';
import GameButton from '../components/GameButton';
import DisclaimerDialog from '../components/DisclaimerDialog';

const UpdatePage: React.FC = () => {
  const navigate = useNavigate();

  const [userName, setUserName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(true);
  const [emailAddress, setEmailAddress] = useState('');

  const showError = (message: string) => {
    setError(message);
    setTimeout(() => {
      setError(null);
    }, 4000);
  };

  useEffect(() => {
    const token = sessionStorage.getItem('userToken');
    const userId = sessionStorage.getItem('userId');
    const storedEmail = sessionStorage.getItem('emailAddress');

    if (!token || !userId) {
      navigate('/register-error');
    }

    if (storedEmail) {
      setEmailAddress(storedEmail);
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!userName.trim() || !displayName.trim() || !password || !confirmPassword) {
      setTimeout(() => {
        showError('All fields are required');
      },0);
        return;
      }

    if (userName.length > 20) {
      setTimeout(() => {
        showError('User name cannot be over 20 characters.')
      },0);
        return;
    }
    else if (displayName.length > 20) {
      setTimeout(() => {
        showError('Display name cannot be over 20 characters.')
      },0);
        return;
    }

    if (password.length < 8) {
      setTimeout(() => {
        showError('Password must be at least 8 characters long');
      },0);
      return;
    }

    if (!/[A-Z]/.test(password)) {
      setTimeout(() => {
        showError('Password must contain at least one uppercase letter');
      },0);
      return;
    }

    if (!/[a-z]/.test(password)) {
      setTimeout(() => {
        showError('Password must contain at least one lowercase letter');
      },0);
      return;
    }

    if (!/[0-9]/.test(password)) {
      setTimeout(() => {
        showError('Password must contain at least one number');
      },0);
      return;
    }

    if (!/[^A-Za-z0-9]/.test(password)) {
      setTimeout(() => {
        showError('Password must contain at least one special character (e.g., !@#$)');
      },0);
      return;
    }

    if (password !== confirmPassword) {
      setTimeout(() => {
        showError('Passwords do not match');
      },0);
      return;
    }

    const token = sessionStorage.getItem('userToken');
    const userId = sessionStorage.getItem('userId');
    const apiUrl = process.env.REACT_APP_GAME_API_URL;
    const apiKey = process.env.REACT_APP_GAME_API_KEY;

    if (!token || !userId) {
      navigate('/register-error');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/users/updateprofile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': apiKey || '',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            userId,
            email: emailAddress.trim().toLowerCase(),
            userName: userName.trim(),
            displayName: displayName.trim(),
            password
          })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Failed to update profile');
      }

      sessionStorage.clear();
      console.log('✅ Registration complete:', data);
      navigate('/login');
      sessionStorage.clear();
    } catch (err: any) {
      setTimeout(() => {
        showError(err.message);
      },0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
        {showDisclaimer && (
      <DisclaimerDialog
        onAccept={() => setShowDisclaimer(false)}
        onDecline={() => navigate('/register-error')}
      />
    )}
    
    <div
      style={{
        minHeight: '60vh',
        maxWidth: '400px',
        margin: '0 auto',
        padding: '2rem',
        color: 'var(--text-normal)'
      }}
    >
      <h1 style={{ color: 'var(--text-header)', textAlign: 'center' }}>Re-Word Alpha Registration</h1>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '0.5rem' }}>User Name</label>
          <input
            type="text"
            maxLength={20}
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            className='input-field'
          />
        </div>

        <div>
        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
            Display Name{' '}
            <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                (Used for high scores)
            </span>
        </label>
          <input
            type="text"
            maxLength={20}
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className='input-field'
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '0.5rem' }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className='input-field'
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '0.5rem' }}>Confirm Password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className='input-field'            
          />
        </div>

        <div
          style={{
            height: '1.1rem',
            color: 'red',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '0.5rem',
            width: '100%',
            }}>
          {error && <span>{error}</span>}
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1.1rem' }}>
            <GameButton
                type="submit"
                label={loading ? 'Saving...' : 'Complete Registration'}

            />
        </div>
      </form>
    </div>
    </>
  );  
};

export default UpdatePage;
